import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Header, navItems } from './Header';
import { HeaderContact } from './HeaderContact';


export const DesktopHeader: React.FC = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				width: '100%',
			}}
		>
			{/* Logo */}
			<Box
				component="img"
				src="/logo.png"
				sx={{ maxHeight: '150px' }}
			/>

			{/* Center content */}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					flexGrow: 1,
				}}
			>
				{/* Contact info */}
				<HeaderContact />

				{/* Navigation */}
				<Box sx={{ pt: 3, display: 'flex', gap: 4 }}>
					{navItems.map((item) => (
						<MuiLink
							key={item.label}
							href={item.href}
							underline="none"
							color="inherit"
							sx={{
								fontWeight: 500,
								fontSize: '1.4rem',
								'&:hover': { color: 'primary.main' },
							}}
						>
							{item.label}
						</MuiLink>
					))}
				</Box>
			</Box>
		</Box>
	);
};